import { Action } from "redux";

import {
  IFetchListCommentRequest,
  IFetchListCommentResponse,
  FetchListCommentAction,
  FetchListCommentSuccessAction,
  FetchListCommentErrorAction,
  ReloadListCommentAction,
  ReloadListCommentSuccessAction,

  CreateCommentRequest,
  CreateCommentAction,
  CreateCommentSuccessAction,
  CreateCommentErrorAction,

  CreateCommunityAction,
  CreateCommunitySuccessAction,
  CreateCommunityErrorAction,

  DeleteCommentRequest,
  DeleteCommentAction,

  FetchStatisticChannelAction,
  FetchStatisticChannelSuccessAction,
  FetchStatisticChannelErrorAction,
  IFetchStatisticChannelRequest,
  FetchListUserPostsAction,
  IFetchListUserPostsRequest,
  FetchListUserPostsSuccessAction,
  FetchListUserPostsErrorAction,
  FetchFollowStatusAction,
  IFetchFollowStatusRequest,
  FetchFollowStatusSuccessAction,
  FetchFollowStatusErrorAction,
  UpdateFollowUserAction,
  UpdateFollowUserSuccessAction,
  UpdateFollowUserErrorAction,
  IUpdateFollowUserRequest,
  ReportPostAction,
  ReportPostSuccessAction,
  ReportPostErrorAction,
  ReportCommentSuccessAction,
  ReportCommentAction,
  IReportCommentRequest,
  IReportPostRequest,
  ReportCommentErrorAction,
  IDeletePostRequest,
  DeletePostAction,
  DeletePostSuccessAction,
  DeletePostErrorAction,
  ReactionPostAction,
  ReactionPostSuccessAction,
  ReactionPostErrorAction,
  FetchDetailPostAction,
  FetchDetailPostSuccessAction,
  FetchDetailPostErrorAction,
  ReactionCommentAction,
  ReactionCommentSuccessAction,
  ReactionCommentErrorAction,
} from './types'

export const FETCH_LIST_TRENDING_COMMUNITY_REQUEST = "FETCH_LIST_TRENDING_COMMUNITY_REQUEST";
export const FETCH_LIST_TRENDING_COMMUNITY_SUCCESS = "FETCH_LIST_TRENDING_COMMUNITY_SUCCESS";
export const FETCH_LIST_TRENDING_COMMUNITY_ERROR = "FETCH_LIST_TRENDING_COMMUNITY_ERROR";

export const FETCH_LIST_FOLLOW_COMMUNITY_REQUEST = "FETCH_LIST_FOLLOW_COMMUNITY_REQUEST";
export const FETCH_LIST_FOLLOW_COMMUNITY_SUCCESS = "FETCH_LIST_FOLLOW_COMMUNITY_SUCCESS";
export const FETCH_LIST_FOLLOW_COMMUNITY_ERROR = "FETCH_LIST_FOLLOW_COMMUNITY_ERROR";

export const FETCH_LIST_VIDEO_COMMUNITY_REQUEST = "FETCH_LIST_VIDEO_COMMUNITY_REQUEST";
export const FETCH_LIST_VIDEO_COMMUNITY_SUCCESS = "FETCH_LIST_VIDEO_COMMUNITY_SUCCESS";
export const FETCH_LIST_VIDEO_COMMUNITY_ERROR = "FETCH_LIST_VIDEO_COMMUNITY_ERROR";

export const CREATE_COMMUNITY_REQUEST = "CREATE_COMMUNITY_REQUEST";
export const CREATE_COMMUNITY_SUCCESS = "CREATE_COMMUNITY_SUCCESS";
export const CREATE_COMMUNITY_ERROR = "CREATE_COMMUNITY_ERROR";
export const RESET_CREATE_COMMUNITY = "RESET_CREATE_COMMUNITY";

// comment
export const FETCH_LIST_COMMENT_REQUEST = "FETCH_LIST_COMMENT_REQUEST";
export const FETCH_LIST_COMMENT_SUCCESS = "FETCH_LIST_COMMENT_SUCCESS";
export const FETCH_LIST_COMMENT_ERROR = "FETCH_LIST_COMMENT_ERROR";
export const RELOAD_LIST_COMMENT_REQUEST = "RELOAD_LIST_COMMENT_REQUEST";
export const RELOAD_LIST_COMMENT_SUCCESS = "RELOAD_LIST_COMMENT_SUCCESS";

export const CREATE_COMMENT_REQUEST = "CREATE_COMMENT_REQUEST";
export const CREATE_COMMENT_SUCCESS = "CREATE_COMMENT_SUCCESS";
export const CREATE_COMMENT_ERROR = "CREATE_COMMENT_ERROR";

export const DELETE_COMMENT_REQUEST = "DELETE_COMMENT_REQUEST";

export const REPORT_COMMENT_REQUEST = "REPORT_COMMENT_REQUEST";
export const REPORT_COMMENT_SUCCESS = "REPORT_COMMENT_SUCCESS";
export const REPORT_COMMENT_ERROR = "REPORT_COMMENT_ERROR";
// end comment

export const FETCH_STATISTIC_CHANNEL_REQUEST = "FETCH_STATISTIC_CHANNEL_REQUEST";
export const FETCH_STATISTIC_CHANNEL_SUCCESS = "FETCH_STATISTIC_CHANNEL_SUCCESS";
export const FETCH_STATISTIC_CHANNEL_ERROR = "FETCH_STATISTIC_CHANNEL_ERROR";

export const FETCH_LIST_USER_POSTS_REQUEST = "FETCH_LIST_USER_POSTS_REQUEST";
export const FETCH_LIST_USER_POSTS_SUCCESS = "FETCH_LIST_USER_POSTS_SUCCESS";
export const FETCH_LIST_USER_POSTS_ERROR = "FETCH_LIST_USER_POSTS_ERROR";
export const RESET_LIST_USER_POSTS = "RESET_LIST_USER_POSTS";

export const FETCH_FOLLOW_STATUS_REQUEST = "FETCH_FOLLOW_STATUS_REQUEST";
export const FETCH_FOLLOW_STATUS_SUCCESS = "FETCH_FOLLOW_STATUS_SUCCESS";
export const FETCH_FOLLOW_STATUS_ERROR = "FETCH_FOLLOW_STATUS_ERROR";

export const UPDATE_FOLLOW_USER_REQUEST = "UPDATE_FOLLOW_USER_REQUEST";
export const UPDATE_FOLLOW_USER_SUCCESS = "UPDATE_FOLLOW_USER_SUCCESS";
export const UPDATE_FOLLOW_USER_ERROR = "UPDATE_FOLLOW_USER_ERROR";

export const REPORT_POST_REQUEST = "REPORT_POST_REQUEST";
export const REPORT_POST_SUCCESS = "REPORT_POST_SUCCESS";
export const REPORT_POST_ERROR = "REPORT_POST_ERROR";

export const DELETE_POST_REQUEST = "DELETE_POST_REQUEST";
export const DELETE_POST_SUCCESS = "DELETE_POST_SUCCESS";
export const DELETE_POST_ERROR = "DELETE_POST_ERROR";

export const UPDATE_LIST_POST = "UPDATE_LIST_POST";

export const REACTION_POST_REQUEST = "REACTION_POST_REQUEST";
export const REACTION_POST_SUCCESS = "REACTION_POST_SUCCESS";
export const REACTION_POST_ERROR = "REACTION_POST_ERROR";

export const FETCH_DETAIL_POST_REQUEST = "FETCH_DETAIL_POST_REQUEST";
export const FETCH_DETAIL_POST_SUCCESS = "FETCH_DETAIL_POST_SUCCESS";
export const FETCH_DETAIL_POST_ERROR = "FETCH_DETAIL_POST_ERROR";

export const REACTION_COMMENT_REQUEST = "REACTION_COMMENT_REQUEST";
export const REACTION_COMMENT_SUCCESS = "REACTION_COMMENT_SUCCESS";
export const REACTION_COMMENT_ERROR = "REACTION_COMMENT_ERROR";


export interface FetchListTrendingCommunityAction
  extends Action<typeof FETCH_LIST_TRENDING_COMMUNITY_REQUEST> {
  payload: any;
}
export interface FetchListTrendingCommunitySuccessAction
  extends Action<typeof FETCH_LIST_TRENDING_COMMUNITY_SUCCESS> {
  payload: any;
}

export interface FetchListTrendingCommunityErrorAction
  extends Action<typeof FETCH_LIST_TRENDING_COMMUNITY_ERROR> {
  payload: Error;
}

export const fetchListTrendingCommunityRequest = (data: any): FetchListTrendingCommunityAction => ({
  type: FETCH_LIST_TRENDING_COMMUNITY_REQUEST,
  payload: data,
});

export const fetchListTrendingCommunitySuccess = (
  data: any
): FetchListTrendingCommunitySuccessAction => ({
  type: FETCH_LIST_TRENDING_COMMUNITY_SUCCESS,
  payload: data,
});

export const fetchListTrendingCommunityError = (error: any): FetchListTrendingCommunityErrorAction => ({
  type: FETCH_LIST_TRENDING_COMMUNITY_ERROR,
  payload: error,
});

// follow community
export interface FetchListFollowCommunityAction
  extends Action<typeof FETCH_LIST_FOLLOW_COMMUNITY_REQUEST> {
  payload: any;
}
export interface FetchListFollowCommunitySuccessAction
  extends Action<typeof FETCH_LIST_FOLLOW_COMMUNITY_SUCCESS> {
  payload: any;
}

export interface FetchListFollowCommunityErrorAction
  extends Action<typeof FETCH_LIST_FOLLOW_COMMUNITY_ERROR> {
  payload: Error;
}

export const fetchListFollowCommunityRequest = (data: any): FetchListFollowCommunityAction => ({
  type: FETCH_LIST_FOLLOW_COMMUNITY_REQUEST,
  payload: data,
});

export const fetchListFollowCommunitySuccess = (
  data: any
): FetchListFollowCommunitySuccessAction => ({
  type: FETCH_LIST_FOLLOW_COMMUNITY_SUCCESS,
  payload: data,
});

export const fetchListFollowCommunityError = (error: any): FetchListFollowCommunityErrorAction => ({
  type: FETCH_LIST_FOLLOW_COMMUNITY_ERROR,
  payload: error,
});


// video community
export interface FetchListVideoCommunityAction
  extends Action<typeof FETCH_LIST_VIDEO_COMMUNITY_REQUEST> {
  payload: any;
}
export interface FetchListVideoCommunitySuccessAction
  extends Action<typeof FETCH_LIST_VIDEO_COMMUNITY_SUCCESS> {
  payload: any;
}

export interface FetchListVideoCommunityErrorAction
  extends Action<typeof FETCH_LIST_VIDEO_COMMUNITY_ERROR> {
  payload: Error;
}

export const fetchListVideoCommunityRequest = (data: any): FetchListVideoCommunityAction => ({
  type: FETCH_LIST_VIDEO_COMMUNITY_REQUEST,
  payload: data,
});

export const fetchListVideoCommunitySuccess = (
  data: any
): FetchListVideoCommunitySuccessAction => ({
  type: FETCH_LIST_VIDEO_COMMUNITY_SUCCESS,
  payload: data,
});

export const fetchListVideoCommunityError = (error: any): FetchListVideoCommunityErrorAction => ({
  type: FETCH_LIST_VIDEO_COMMUNITY_ERROR,
  payload: error,
});

// create community
export const createCommunityRequest = (data: any): CreateCommunityAction => ({
  type: CREATE_COMMUNITY_REQUEST,
  payload: data,
});
export const createCommunitySuccess = (data: any): CreateCommunitySuccessAction => ({
  type: CREATE_COMMUNITY_SUCCESS,
  payload: data,
});
export const createCommunityError = (error: Error): CreateCommunityErrorAction => ({
  type: CREATE_COMMUNITY_ERROR,
  payload: error,
});
export const resetCreateCommunity = (): Action => ({
  type: RESET_CREATE_COMMUNITY,
});

// list comment
export const fetchListCommentRequest = (
  params: IFetchListCommentRequest
): FetchListCommentAction => ({
  type: FETCH_LIST_COMMENT_REQUEST,
  payload: params,
});
export const fetchListCommentSuccess = (
  data: IFetchListCommentResponse
): FetchListCommentSuccessAction => ({
  type: FETCH_LIST_COMMENT_SUCCESS,
  payload: data,
});
export const fetchListCommentError = (
  error: Error
): FetchListCommentErrorAction => ({
  type: FETCH_LIST_COMMENT_ERROR,
  payload: error,
});

export const reloadListCommentRequest = (
  params: IFetchListCommentRequest
): ReloadListCommentAction => ({
  type: RELOAD_LIST_COMMENT_REQUEST,
  payload: params,
});
export const reloadListCommentSuccess = (
  data: IFetchListCommentResponse
): ReloadListCommentSuccessAction => ({
  type: RELOAD_LIST_COMMENT_SUCCESS,
  payload: data,
});
// end comment list
// create comment
export const createCommentRequest = (
  data: CreateCommentRequest
): CreateCommentAction => ({
  type: CREATE_COMMENT_REQUEST,
  payload: data,
});
export const createCommentSuccess = (
  data: any
): CreateCommentSuccessAction => ({
  type: CREATE_COMMENT_SUCCESS,
  payload: data,
});
export const createCommentError = (
  error: Error
): CreateCommentErrorAction => ({
  type: CREATE_COMMENT_ERROR,
  payload: error,
});
// end create comment
// delete comment
export const deleteCommentRequest = (
  data: DeleteCommentRequest
): DeleteCommentAction => ({
  type: DELETE_COMMENT_REQUEST,
  payload: data,
});
// end delete comment

// report comment
export const reportCommentRequest = (
  params: IReportCommentRequest
): ReportCommentAction => ({
  type: REPORT_COMMENT_REQUEST,
  payload: params,
});
export const reportCommentSuccess = (
  data: any
): ReportCommentSuccessAction => ({
  type: REPORT_COMMENT_SUCCESS,
  payload: data,
});
export const reportCommentError = (
  error: Error
): ReportCommentErrorAction => ({
  type: REPORT_COMMENT_ERROR,
  payload: error,
});
// end report comment

export const fetchStatisticChannelRequest = (
  params: IFetchStatisticChannelRequest
): FetchStatisticChannelAction => ({
  type: FETCH_STATISTIC_CHANNEL_REQUEST,
  payload: params,
});
export const fetchStatisticChannelSuccess = (
  data: any
): FetchStatisticChannelSuccessAction => ({
  type: FETCH_STATISTIC_CHANNEL_SUCCESS,
  payload: data,
});
export const fetchStatisticChannelError = (
  error: Error
): FetchStatisticChannelErrorAction => ({
  type: FETCH_STATISTIC_CHANNEL_ERROR,
  payload: error,
});

export const fetchListUserPostsRequest = (
  params: IFetchListUserPostsRequest
): FetchListUserPostsAction => ({
  type: FETCH_LIST_USER_POSTS_REQUEST,
  payload: params,
});
export const fetchListUserPostsSuccess = (
  data: any
): FetchListUserPostsSuccessAction => ({
  type: FETCH_LIST_USER_POSTS_SUCCESS,
  payload: data,
});
export const fetchListUserPostsError = (
  error: Error
): FetchListUserPostsErrorAction => ({
  type: FETCH_LIST_USER_POSTS_ERROR,
  payload: error,
});

export const fetchFollowStatusRequest = (
  params: IFetchFollowStatusRequest
): FetchFollowStatusAction => ({
  type: FETCH_FOLLOW_STATUS_REQUEST,
  payload: params,
});
export const fetchFollowStatusSuccess = (
  data: any
): FetchFollowStatusSuccessAction => ({
  type: FETCH_FOLLOW_STATUS_SUCCESS,
  payload: data,
});
export const fetchFollowStatusError = (
  error: Error
): FetchFollowStatusErrorAction => ({
  type: FETCH_FOLLOW_STATUS_ERROR,
  payload: error,
});

export const updateFollowUserRequest = (
  params: IUpdateFollowUserRequest
): UpdateFollowUserAction => ({
  type: UPDATE_FOLLOW_USER_REQUEST,
  payload: params,
});
export const updateFollowUserSuccess = (
  data: any
): UpdateFollowUserSuccessAction => ({
  type: UPDATE_FOLLOW_USER_SUCCESS,
  payload: data,
});
export const updateFollowUserError = (
  error: Error
): UpdateFollowUserErrorAction => ({
  type: UPDATE_FOLLOW_USER_ERROR,
  payload: error,
});

export const reportPostRequest = (
  params: IReportPostRequest
): ReportPostAction => ({
  type: REPORT_POST_REQUEST,
  payload: params,
});
export const reportPostSuccess = (
  data: any
): ReportPostSuccessAction => ({
  type: REPORT_POST_SUCCESS,
  payload: data,
});
export const reportPostError = (
  error: Error
): ReportPostErrorAction => ({
  type: REPORT_POST_ERROR,
  payload: error,
});

export const deletePostRequest = (
  params: IDeletePostRequest
): DeletePostAction => ({
  type: DELETE_POST_REQUEST,
  payload: params,
});
export const deletePostSuccess = (
  data: any
): DeletePostSuccessAction => ({
  type: DELETE_POST_SUCCESS,
  payload: data,
});
export const deletePostError = (
  error: Error
): DeletePostErrorAction => ({
  type: DELETE_POST_ERROR,
  payload: error,
});

export const updateListPost = (
  data: any
): any => ({
  type: UPDATE_LIST_POST,
  payload: data,
});

export const reactionPostRequest = (
  params: any
): ReactionPostAction => {
  return {
    type: REACTION_POST_REQUEST,
    payload: params,
  }
};

export const reactionPostSuccess = (
  data: any
): ReactionPostSuccessAction => {
  return {
    type: REACTION_POST_SUCCESS,
    payload: data,
  }
};

export const reactionPostError = (
  error: Error
): ReactionPostErrorAction => ({
  type: REACTION_POST_ERROR,
  payload: error,
});

export const fetchDetailPostRequest = (
  params: any
): FetchDetailPostAction => ({
  type: FETCH_DETAIL_POST_REQUEST,
  payload: params,
});
export const fetchDetailPostSuccess = (
  data: any
): FetchDetailPostSuccessAction => ({
  type: FETCH_DETAIL_POST_SUCCESS,
  payload: data,
});
export const fetchDetailPostError = (
  error: Error
): FetchDetailPostErrorAction => ({
  type: FETCH_DETAIL_POST_ERROR,
  payload: error,
});

export const resetListUserPosts = (
  data?: any
): any => ({
  type: RESET_LIST_USER_POSTS,
  payload: data,
});

export const reactionCommentRequest = (
  params: any
): ReactionCommentAction => ({
  type: REACTION_COMMENT_REQUEST,
  payload: params,
});
export const reactionCommentSuccess = (
  data: any
): ReactionCommentSuccessAction => ({
  type: REACTION_COMMENT_SUCCESS,
  payload: data,
});
export const reactionCommentError = (
  error: Error
): ReactionCommentErrorAction => ({
  type: REACTION_COMMENT_ERROR,
  payload: error,
});
